import { Component, Input, OnInit } from '@angular/core';
import { TranslatableKey } from '@app/types/translatable.type';
import { convertToBase26Alpha } from '@import/functions/convert-to-base-26-alpha';
import { UnmatchedItems as UnmatchedItemsInterface } from '@import/interfaces/unmatched-items.interface';

@Component({
    selector: 'app-unmatched-items',
    templateUrl: './unmatched-items.template.html',
    styleUrls: ['./unmatched-items.style.scss'],
})
export class UnmatchedItems implements OnInit {
    @Input() itemType: string;
    @Input() helperText: string;
    @Input() unmatchedList: UnmatchedItemsInterface[];

    itemTypeTranslationKey: TranslatableKey = '';
    allItemsMatched: TranslatableKey = '';
    remainingItemsMatched: TranslatableKey = '';

    ngOnInit(): void {
        this.itemTypeTranslationKey =
            this.itemType === 'Columns'
                ? 'import.unmatchedItems.unmatchedColumns'
                : 'import.unmatchedItems.unmatchedValues';

        this.allItemsMatched =
            this.itemType === 'Columns'
                ? 'import.unmatchedItems.allColumnsMatched'
                : 'import.unmatchedItems.allValuesMatched';

        this.remainingItemsMatched =
            this.itemType === 'Columns'
                ? 'import.unmatchedItems.remainingColumns'
                : 'import.unmatchedItems.remainingValues';
    }

    convertToBase26Alpha = convertToBase26Alpha;
}
